import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import csLocale from 'dayjs/locale/cs';
import plLocale from 'dayjs/locale/pl';
import enLocale from 'dayjs/locale/en';
import skLocale from 'dayjs/locale/sk';

const localeMap: Record<string, any> = {
    cs: csLocale,
    pl: plLocale,
    en: enLocale,
    sk: skLocale
};


export interface ILocalizationProviderWithLanguagesProps {
    children: React.ReactNode;
}

export default function LocalizationProviderWithLanguages(props: ILocalizationProviderWithLanguagesProps) {
    const { t, i18n } = useTranslation();

    React.useEffect(() => {
        // Set locale when language changes
        const currentLocale = i18n.language;
        dayjs.locale(currentLocale);
    }, [i18n.language]);

    return (
        <LocalizationProvider localeText={{
            cancelButtonLabel: t('Cancel'),
            clearButtonLabel: t('Clear'),
            okButtonLabel: t('OK'),
            todayButtonLabel: t('Today'),
            datePickerDefaultToolbarTitle: t('SelectDate'),
            previousMonth: t('previousMonth'),
            nextMonth: t('nextMonth'),
            openPreviousView: t('openPreviousView'),
            openNextView: t('openNextView'),
            start: t('start'),
            end: t('end'),
            timeTableLabel: t('timeTableLabel'),
            dateTableLabel: t('dateTableLabel'),
            dateTimePickerDefaultToolbarTitle: t('dateTimePickerDefaultToolbarTitle'),
            timePickerDefaultToolbarTitle: t('timePickerDefaultToolbarTitle'),
            dateRangePickerDefaultToolbarTitle: t('dateRangePickerDefaultToolbarTitle')
        }} adapterLocale={i18n.language} dateAdapter={AdapterDayjs}>
            {props.children}
        </LocalizationProvider>
    );
}
